<template>
  <main>
    <Banner />
    <News />
    <!-- <Company /> -->
    <ContactUs />
  </main>
</template>

<script>
import Banner from './Banner.vue'
import News from './News.vue'
// import Company from './Company.vue'
import ContactUs from './ContactUs.vue'

export default {
  components: {
    Banner,
    News,
    // Company,
    ContactUs
  }
}
</script>

<style lang="scss" scoped>
.home-container {
  @include InnerContainer();
}
</style>
